// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".WhatsApp\n{\n    display: inline-flex;\n    align-items: center;\n    margin: 16px 0;\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.WhatsApp-img\n{\n    height: 20px;\n    width: 20px;\n    border-radius: 3px;\n    margin-left: 8px;\n}", ""]);
// Exports
module.exports = exports;
